import { useNavigate, useRouterState } from '@tanstack/react-router'
import {
  Activity,
  Building2,
  CalendarCheck,
  CalendarDays,
  Database,
  Server,
  Users,
} from 'lucide-react'
import { spacing } from '@/components/ui'

const TABS: Array<[string, string, React.ReactNode]> = [
  ['/admin/events', 'Validation', <CalendarCheck size={16} />],
  ['/admin/all-events', 'Événements', <CalendarDays size={16} />],
  ['/admin/users', 'Utilisateurs', <Users size={16} />],
  ['/admin/entities', 'Entités', <Building2 size={16} />],
  ['/admin/scrapers', 'Scrapers', <Server size={16} />],
  ['/admin/profiling', 'Profiling', <Activity size={16} />],
  ['/admin/view', 'Système', <Database size={16} />],
]

/** Sub-navigation shared by all admin pages. */
export default function AdminTabs() {
  const navigate = useNavigate()
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  return (
    <div
      style={{
        display: 'inline-flex',
        gap: 2,
        background: 'var(--surface-sunken)',
        borderRadius: 'var(--radius-pill)',
        padding: 4,
        marginBottom: spacing.xl,
      }}
    >
      {TABS.map(([to, label, icon]) => {
        const on = pathname === to
        return (
          <button
            key={to}
            onClick={() => navigate({ to } as never)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'var(--font-body)',
              fontSize: 14,
              fontWeight: 600,
              padding: '8px 16px',
              borderRadius: 'var(--radius-pill)',
              background: on ? 'var(--surface-card)' : 'transparent',
              color: on ? 'var(--emerald-800)' : 'var(--ink-2)',
              boxShadow: on ? 'var(--shadow-xs)' : 'none',
            }}
          >
            {icon}
            {label}
          </button>
        )
      })}
    </div>
  )
}
